import * as React from 'react';

import { Breadcrumb, BreadcrumbItem, Button, Col, Row } from 'react-bootstrap';
// import { find } from 'lodash';
import { withTranslation, WithTranslation } from 'react-i18next';

import {
    Ibuilding,
    Ifacility,
    Ifloor,
    Ilocation,
    ImanageLocationReducer,
    Iroom,
    ItableFiltersReducer,
    Itile,
    Iuser
} from '../../models';
import ReactTable, { FinalState, RowInfo, SortingRule } from 'react-table';
import {
    closeAllModals,
    getFacilitiesByCountry
} from '../../actions/commonActions';
import {
    deleteAnyLocation,
    filterLocations,
    saveAnyLocation,
    setTableFilter,
    toggleEditLocationModal,
    updateAnyLocation
} from '../../actions/manageLocationActions';
import {
    emptyTile,
    initialBuilding,
    initialFacility,
    initialFloor,
    initialLoc
} from '../../reducers/initialState';

import { AddButton } from '../common/AddButton';
import { Banner } from '../common/Banner';
import EditLocationModal from './EditLocationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/*
 * hopsital Managers manage their locations
 */
import { RouteComponentProps } from 'react-router-dom';
import { TableUtil } from '../common/TableUtil';
import { connect } from 'react-redux';
import { constants } from '../../constants/constants';
import { toastr } from 'react-redux-toastr';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IinitialState } from '../../reducers';
import { selectVisibleLocations } from '../../reducers/manageLocationReducer';
import { selectSelectedFacilityID } from '../../reducers/facilitiesReducer';
import { FiltersHeightDiv } from '../common/FiltersHeightDiv';

interface Iprops extends RouteComponentProps<any> {
    // Add your regular properties here

    showEditLocationModal: boolean;
    loading: boolean;
    userManage: ImanageLocationReducer;
}

interface IdispatchProps {
    // Add your dispatcher properties here
    toggleEditLocationModal: typeof toggleEditLocationModal;
    saveAnyLocation: typeof saveAnyLocation;
    updateAnyLocation: typeof updateAnyLocation;
    deleteAnyLocation: typeof deleteAnyLocation;
    closeAllModals: typeof closeAllModals;
    selectedFacilityID: string;
    user: Iuser;
    tableData: any[];
    selectedFacility: Ifacility;
    setTableFilter: typeof setTableFilter;
    tableFilters: ItableFiltersReducer;
    selectedBuilding: Ibuilding;
    selectedFloor: Ifloor;
    selectedLocation: Ilocation;
    filterLocations: typeof filterLocations;
    getFacilitiesByCountry: typeof getFacilitiesByCountry;
}

interface Istate {
    selectedRow: any;
    currentTile: Itile;
    columns: any[];
    selectedItem: any;
    // Remembered "Path" so breadcrumb layer names persist when navigating back
    // (redux tableFilters clear the selection on back-nav).
    pathMemory: {
        building: { id: string; name: string } | null;
        floor: { id: string; name: string } | null;
        location: { id: string; name: string } | null;
    };
}

class ManageLocation extends React.Component<
    Iprops & IdispatchProps & WithTranslation,
    Istate
> {
    // public searchFieldConfig: any;
    public searchFieldConfigBanner: any;
    public buttonInAction = false;
    public deleteAction = false;
    private setTableFilterTimeout: any;
    constructor(props: Iprops & IdispatchProps & WithTranslation) {
        super(props);
        this.state = {
            selectedRow: {},
            currentTile: emptyTile,
            columns: [],
            selectedItem: {},
            pathMemory: { building: null, floor: null, location: null }
        };
    }

    componentDidMount() {
        this.setState({
            currentTile: constants.getTileByURL(this.props.location.pathname)
        });
        this.setColumns();

        this.props.filterLocations(this.props.selectedFacilityID);
        this.props.getFacilitiesByCountry({
            name: this.props.selectedFacility.name
        });

        this.props.i18n.on('languageChanged', () => {
            this.setColumns();
        });
    }
    componentDidUpdate(prevProps: Iprops & IdispatchProps) {
        if (
            JSON.stringify(prevProps.tableFilters) !==
            JSON.stringify(this.props.tableFilters)
        ) {
            this.props.filterLocations(this.props.selectedFacilityID);
            // scroll top every time a filter changes
            const tableDiv = document.getElementsByClassName('rt-tbody');
            if (tableDiv && tableDiv.length) {
                tableDiv[0].scrollTop = 0;
            }
        }

        // update the table with new or edited locationObjets when the facility changes
        if (
            JSON.stringify(prevProps.selectedFacility) !==
            JSON.stringify(this.props.selectedFacility)
        ) {
            this.props.filterLocations(this.props.selectedFacilityID);
        }

        // Breadcrumb "Path" memory: reset on facility change (buildings differ
        // per facility), otherwise sync to the current selection so remembered
        // layer names persist when the user navigates back.
        if (
            JSON.stringify(prevProps.selectedFacility) !==
            JSON.stringify(this.props.selectedFacility)
        ) {
            this.setState({
                pathMemory: { building: null, floor: null, location: null }
            });
        } else {
            this.syncPathMemory();
        }

        // if (prevProps.facility.id !== this.props.facility.id) {
        //   this.props.setSelectedFacility(this.props.facility);
        // }
    }

    componentWillUnmount() {
        this.props.closeAllModals();
    }

    handleEdit(selectedItem: any) {
        this.setState({ selectedItem });
        // console.info("EDIT:", item);
    }

    handleDelete(deletedItem: Ilocation | Ibuilding | Ifloor | Iroom) {
        const toastrConfirmOptions = {
            onOk: () => {
                deletedItem = {
                    ...deletedItem,
                    buildingID: this.props.selectedBuilding.id,
                    floorID: this.props.selectedFloor.id,
                    locationID: this.props.selectedLocation.id
                };
                this.props.deleteAnyLocation(
                    deletedItem,
                    this.props.selectedFacilityID
                );
                console.info('deleted', deletedItem);
            },
            onCancel: () => console.info('CANCEL: clicked'),
            okText: this.props.t('deleteOk'),
            cancelText: this.props.t('common:cancel')
        };
        toastr.confirm(this.props.t('deleteConfirm'), toastrConfirmOptions);
    }

    /*
     * Reset the table filters (not used currently)
     */
    resetTableFilters = () => {
        this.props.setTableFilter({
            search: '',
            page: 1
        });
    };

    /*
     * Set Columns sets columns to state
     */
    setColumns = () => {
        const columns = TableUtil.translateHeaders(
            [
                {
                    Header: 'manageInventory:name',
                    accessor: 'name',
                    minWidth: 300
                },
                {
                    Header: '',
                    Cell: row => (
                        <div>
                            <Button
                                bsStyle="link"
                                style={{ float: 'right', marginRight: 11 }}
                                onClick={() => {
                                    this.buttonInAction = true;
                                    this.handleEdit(row.original);
                                }}
                            >
                                <FontAwesomeIcon icon={['far', 'edit']} />
                            </Button>
                            <Button
                                bsStyle="link"
                                style={{ float: 'right', color: 'red' }}
                                onClick={() => {
                                    this.buttonInAction = true;
                                    this.deleteAction = true;
                                    this.handleDelete(row.original);
                                }}
                            >
                                <FontAwesomeIcon icon={['far', 'times']} />
                            </Button>
                        </div>
                    )
                }
            ],
            this.props.t
        );
        this.setState({ columns });
    };

    /*
     * Handle user clicking on a location row
     * set the selected location to state and open the modal
     */
    getTrProps = (state: FinalState, rowInfo: RowInfo | undefined) => {
        if (rowInfo) {
            const rowObject = rowInfo.original || {};
            // A room is the leaf level (its row object has no facility/building/
            // floor parent id). Rooms can't be drilled into, so flag the row to
            // drop the clickable affordances (pointer cursor + hover highlight).
            const isRoom =
                !('facilityID' in rowObject) &&
                !('buildingID' in rowObject) &&
                !('floorID' in rowObject);
            return {
                className: isRoom ? 'leaf-row' : '',
                onClick: (evt: React.MouseEvent<HTMLFormElement>) => {
                    const locationObject = rowInfo.original as
                        | Ilocation
                        | Ibuilding
                        | Ifloor
                        | Iroom;
                    if (this.buttonInAction && this.deleteAction === false) {
                        this.props.toggleEditLocationModal();
                    } else if (this.deleteAction === false) {
                        if ('facilityID' in locationObject) {
                            // BUILDING
                            this.props.setTableFilter({
                                buildingID: locationObject.id,
                                locationID: undefined,
                                floorID: undefined
                            });
                        } else if ('buildingID' in locationObject) {
                            // FLOOR
                            this.props.setTableFilter({
                                locationID: undefined,
                                floorID: locationObject.id
                            });
                        } else if ('floorID' in locationObject) {
                            // LOCATION
                            this.props.setTableFilter({
                                locationID: locationObject.id
                            });
                        } else {
                            // ROOM - we don't do anthything when they select a room...
                        }
                    }
                    this.buttonInAction = false;
                    this.deleteAction = false;
                },
                style: {
                    background: this.state.selectedRow[rowInfo.viewIndex]
                        ? constants.colors[
                              `${this.state.currentTile.color}Tr` as keyof typeof constants.colors
                          ]
                        : ''
                }
            };
        } else {
            return {};
        }
    };

    // get location type
    getLocationType = () => {
        if (this.props.selectedLocation.id.length) {
            return 'Room';
        } else if (this.props.selectedFloor.id.length) {
            return 'Location';
        } else if (this.props.selectedBuilding.id.length) {
            return 'Floor';
        } else {
            return 'Building';
        }
    };

    // Keep pathMemory in sync with the current selection. Entering a different
    // container at a level clears the remembered deeper levels (they revert to
    // placeholders); navigating back leaves the memory intact.
    syncPathMemory = () => {
        const {
            selectedBuilding,
            selectedFloor,
            selectedLocation
        } = this.props;
        const mem = this.state.pathMemory;
        const next = { ...mem };
        let changed = false;

        if (selectedBuilding.id) {
            if (!mem.building || mem.building.id !== selectedBuilding.id) {
                next.building = {
                    id: selectedBuilding.id,
                    name: selectedBuilding.name
                };
                next.floor = null;
                next.location = null;
                changed = true;
            }
        }
        if (selectedFloor.id) {
            if (!next.floor || next.floor.id !== selectedFloor.id) {
                next.floor = { id: selectedFloor.id, name: selectedFloor.name };
                next.location = null;
                changed = true;
            }
        }
        if (selectedLocation.id) {
            if (!next.location || next.location.id !== selectedLocation.id) {
                next.location = {
                    id: selectedLocation.id,
                    name: selectedLocation.name
                };
                changed = true;
            }
        }
        if (changed) {
            this.setState({ pathMemory: next });
        }
    };

    // Navigate the "Path". Uses remembered ids so a click can jump forward to a
    // previously-visited layer as well as back to an ancestor.
    goToLevel = (
        level: 'Facility' | 'Building' | 'Floor' | 'Location',
        e: React.MouseEvent<HTMLAnchorElement>
    ) => {
        e.preventDefault();
        const mem = this.state.pathMemory;
        const buildingID = mem.building ? mem.building.id : undefined;
        const floorID = mem.floor ? mem.floor.id : undefined;
        const locationID = mem.location ? mem.location.id : undefined;
        switch (level) {
            case 'Facility':
                this.props.setTableFilter({
                    buildingID: undefined,
                    floorID: undefined,
                    locationID: undefined
                });
                break;
            case 'Building':
                this.props.setTableFilter({
                    buildingID,
                    floorID: undefined,
                    locationID: undefined
                });
                break;
            case 'Floor':
                this.props.setTableFilter({
                    buildingID,
                    floorID,
                    locationID: undefined
                });
                break;
            case 'Location':
                this.props.setTableFilter({
                    buildingID,
                    floorID,
                    locationID
                });
                break;
            default:
                break;
        }
    };

    // Render one "Path" crumb. 'current' = the layer you're on (active grey),
    // 'link' = a visited/remembered layer (blue, clickable), 'placeholder' =
    // a not-yet-visited layer (lighter grey, not clickable).
    renderCrumb = (
        key: string,
        label: string,
        variant: 'link' | 'current' | 'placeholder',
        onClick?: (e: any) => void
    ) => {
        if (variant === 'link') {
            return (
                <BreadcrumbItem key={key} active>
                    <a href="#" onClick={onClick}>
                        {label}
                    </a>
                </BreadcrumbItem>
            );
        }
        if (variant === 'placeholder') {
            // active (so no anchor is rendered) + a span carrying the lighter
            // placeholder grey, distinct from the current crumb's grey.
            return (
                <BreadcrumbItem key={key} active>
                    <span className="breadcrumb-placeholder">{label}</span>
                </BreadcrumbItem>
            );
        }
        // current ("you are here")
        return (
            <BreadcrumbItem key={key} active>
                {label}
            </BreadcrumbItem>
        );
    };

    // get breadcrumb path - always shows every layer (Buildings > Building >
    // Floor > Location > Room). Visited layers are blue/clickable, the current
    // layer is active, and not-yet-visited layers are greyed placeholders.
    // Remembered names (pathMemory) persist when navigating back so the user
    // can jump forward again.
    getBreadcrumbs = () => {
        const type = this.getLocationType();
        const mem = this.state.pathMemory;
        const {
            selectedBuilding,
            selectedFloor,
            selectedLocation
        } = this.props;

        const buildingName = selectedBuilding.id
            ? selectedBuilding.name
            : mem.building
            ? mem.building.name
            : 'Building';
        const floorName = selectedFloor.id
            ? selectedFloor.name
            : mem.floor
            ? mem.floor.name
            : 'Floor';
        const locationName = selectedLocation.id
            ? selectedLocation.name
            : mem.location
            ? mem.location.name
            : 'Location';

        const hasBuilding = !!(selectedBuilding.id || mem.building);
        const hasFloor = !!(selectedFloor.id || mem.floor);
        const hasLocation = !!(selectedLocation.id || mem.location);

        return (
            <Breadcrumb>
                {this.renderCrumb(
                    'root',
                    'Buildings',
                    type === 'Building' ? 'current' : 'link',
                    e => this.goToLevel('Facility', e)
                )}
                {this.renderCrumb(
                    'building',
                    buildingName,
                    type === 'Floor'
                        ? 'current'
                        : hasBuilding
                        ? 'link'
                        : 'placeholder',
                    e => this.goToLevel('Building', e)
                )}
                {this.renderCrumb(
                    'floor',
                    floorName,
                    type === 'Location'
                        ? 'current'
                        : hasFloor
                        ? 'link'
                        : 'placeholder',
                    e => this.goToLevel('Floor', e)
                )}
                {this.renderCrumb(
                    'location',
                    locationName,
                    type === 'Room'
                        ? 'current'
                        : hasLocation
                        ? 'link'
                        : 'placeholder',
                    e => this.goToLevel('Location', e)
                )}
            </Breadcrumb>
        );
    };

    // get the next or previous page of data.  the table is 0 indexed but the API is not
    onPageChange = (page: number) => {
        const newPage = page + 1;
        this.props.setTableFilter({ page: newPage });
    };

    /*
     * (reusable)
     * set the table filters to redux on each value change
     */
    onSearchValueChanges = (value: any, key: string) => {
        switch (key) {
            case 'search':
                clearTimeout(this.setTableFilterTimeout);
                this.setTableFilterTimeout = setTimeout(() => {
                    this.props.setTableFilter({ search: value, page: 1 }); // this causes performance issues so we use a rudamentary debounce
                }, constants.tableSearchDebounceTime);
                break;
            default:
                break;
        }
    };
    onSortedChanged = (
        newSorted: SortingRule[],
        column: any,
        shiftKey: boolean
    ) => {
        this.props.setTableFilter({ sorted: newSorted });
        this.setState({ selectedRow: {} });
    };

    render() {
        const { t } = this.props;

        return (
            <FiltersHeightDiv className="manage-location">
                <Banner
                    title={t('bannerTitle')}
                    img={this.state.currentTile.srcBanner}
                    color="blue"
                />
                <Row>
                    <Col md={10}>{this.getBreadcrumbs()}</Col>
                    <Col md={2}>
                        <AddButton
                            style={{ marginTop: '8px' }}
                            onClick={() => {
                                this.setState({ selectedItem: {} }, () => {
                                    this.props.toggleEditLocationModal();
                                });
                            }}
                            label={t(
                                `manageLocation:new${this.getLocationType()}`
                            )}
                        />
                    </Col>
                </Row>
                <ReactTable
                    data={this.props.tableData}
                    columns={this.state.columns}
                    getTrProps={this.getTrProps}
                    // pageSize={this.props.tableData.length}
                    // manual
                    // pages={this.props.userManage.totalPages}
                    // page={this.props.tableFilters.page - 1}
                    // showPageSizeOptions={false}
                    defaultPageSize={10}
                    minRows={0}
                    className="beacon-table -highlight blue"
                    previousText={t('common:previous')}
                    nextText={t('common:next')}
                    // onPageChange={this.onPageChange}
                    // onSortedChange={this.onSortedChanged}
                    sortable={false}
                    multiSort={false}
                    noDataText={t('common:noDataText')}
                    resizable={false}
                    expanded={this.state.selectedRow}
                />
                <EditLocationModal
                    selectedItem={this.state.selectedItem}
                    selectedType={this.getLocationType()}
                    colorButton={
                        constants.colors[
                            `${this.state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                />
            </FiltersHeightDiv>
        );
    }
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    const selectedFacilityID = selectSelectedFacilityID(state);
    const selectedFacility =
        state.facilities[selectedFacilityID] &&
        state.facilities[selectedFacilityID].buildings
            ? state.facilities[selectedFacilityID]
            : initialFacility;

    const selectedBuilding =
        selectedFacility.buildings.find(
            building =>
                building.id === state.manageLocation.tableFilters.buildingID
        ) || initialBuilding;
    const selectedFloor =
        selectedBuilding.floors.find(
            floor => floor.id === state.manageLocation.tableFilters.floorID
        ) || initialFloor;
    const selectedLocation =
        selectedFloor.locations.find(
            location =>
                location.id === state.manageLocation.tableFilters.locationID
        ) || initialLoc;
    return {
        selectedFacilityID,
        user: state.user,
        userManage: state.manageLocation,
        loading: selectIsLoading(state),
        showEditLocationModal: state.manageLocation.showEditLocationModal,
        tableData: selectVisibleLocations(state),
        selectedFacility,
        tableFilters: state.manageLocation.tableFilters,
        selectedBuilding,
        selectedFloor,
        selectedLocation
    };
};
export default withTranslation('manageLocation')(
    connect(mapStateToProps, {
        saveAnyLocation,
        updateAnyLocation,
        deleteAnyLocation,
        toggleEditLocationModal,
        closeAllModals,
        setTableFilter,
        filterLocations,
        getFacilitiesByCountry
    })(ManageLocation)
);
